export default {
  setAccountTags (state, accountTags) {
    state.accountTags = accountTags
  },

  setAccountTagsLoading (state, accountTagsLoading) {
    state.accountTagsLoading = accountTagsLoading
  }
}
